/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import styles from './dropdown.scss';

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
        href=""
        ref={ref}
        style={{
            cursor: "pointer",
            display: 'flex',
            padding: '9px 20px 9px 20px',
            border: 'none',
            borderRadius: 24,
            backgroundColor: "#007fa3",
            alignItems: 'center',
            float: "right",
            whiteSpace: 'nowrap',
            height:"46px",
            marginLeft:"16px",
           
             }}
             className ="Button Button-BG"
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        <span style={{
            flexGrow: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'start',
            fontFamily: 'OpenSans-bold', fontSize: 16, lineHeight: '26px',
            overflow: "hidden",
            marginRight: 10,
            textOverflow: 'ellipsis',
            minWidth: 0,
            display: 'inline-block',
            height: 26,
            color:"#ffffff"
        }}>{children}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <defs>
                <filter id="ogkoflajoa">
                    <feColorMatrix in="SourceGraphic" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0" />
                </filter>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <g>
                    <g filter="url(#ogkoflajoa)" transform="translate(-86 -14) translate(86 14)">
                        <path d="M0 0H18V18H0z" />
                        <path fill="#6A7070" d="M9.622 12.762c-.368.33-.932.317-1.284-.039l-5.064-5.11c-.365-.368-.365-.967 0-1.336.366-.37.96-.37 1.325 0L9 10.718l4.4-4.441c.367-.37.96-.37 1.326 0 .365.369.365.968 0 1.337l-5.064 5.11-.04.038z" />
                    </g>
                </g>
            </g>
        </svg>
    </div>
));

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
    (props, ref) => {
        const { multiple, children, style, className, 'Button export-btn btn-font': labeledBy, onSelect, selectAllLabel, onSelectAll, selectAllActive } = props;

        const childrenArray = React.Children.toArray(children);
        return (
            <div
                ref={ref}
                style={{
                    ...style,
                    padding: '10px 0',
                    border: '1.5px solid #b6bfcc',
                }}
                className={className}
                aria-labelledby={labeledBy}
            >

                <ul className="list-unstyled export" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 0,
                    margin: 0,
                    maxHeight: 300,
                    overflowY: 'auto'
                }}>
                    {multiple && (
                        <li
                            className={styles['dropdown-item']}
                            onClick={() => onSelectAll()}
                            style={{ padding: '0 12px', listStyleType: 'none', marginBottom: 10 }}
                        >
                            <span
                                width={20} height={20}
                                style={{
                                    border: selectAllActive ? '1.5px solid #ea067e' : '1.5px solid #b6bfcc',
                                    top: 3,
                                    background: selectAllActive ? '#fce6f2' : 'white',
                                    borderRadius: 3,
                                    marginRight: 8,
                                    position: 'relative',
                                    width: 20,
                                    height: 20
                                }}
                            >
                                {selectAllActive && <span style={{
                                    content: '',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 1,
                                    left: 6,
                                    width: 6,
                                    height: 14,
                                    border: 'solid #ea067e',
                                    borderWidth: '0 2px 2px 0',
                                    transform: 'rotate(45deg)',
                                }} />}
                            </span>
                            <span style={{
                                fontFamily: 'OpenSans', fontSize: 16, lineHeight: '26px',
                                textAlign: 'start',
                                float: 'none',
                                overflow: "hidden",
                                wordBreak: 'break-word'
                            }}>{selectAllLabel}</span>
                        </li>
                    )}
                    {childrenArray.map(
                        (child, index) => {
                            const isSelected = child.props.active || false;
                            return <li
                                className={styles['dropdown-item']}
                                onClick={() => onSelect(child.props.id)}
                                style={{ padding: '0 12px', listStyleType: 'none', marginBottom: index < childrenArray.length - 1 ? 10 : undefined }}
                            >
                                {multiple && (
                                    <span
                                        width={20} height={20}
                                        style={{
                                            border: isSelected ? '1.5px solid #ea067e' : '1.5px solid #b6bfcc',
                                            top: 3,
                                            background: isSelected ? '#fce6f2' : 'white',
                                            borderRadius: 3,
                                            marginRight: 8,
                                            position: 'relative',
                                            width: 20,
                                            height: 20
                                        }}
                                    >
                                        {isSelected && <span style={{
                                            content: '',
                                            display: 'block',
                                            position: 'absolute',
                                            top: 1,
                                            left: 6,
                                            width: 6,
                                            height: 14,
                                            border: 'solid #ea067e',
                                            borderWidth: '0 2px 2px 0',
                                            transform: 'rotate(45deg)',
                                        }} />}
                                    </span>
                                )}
                                <span style={{
                                    fontFamily: 'OpenSans', fontSize: 16, lineHeight: '26px',
                                    textAlign: 'start',
                                    float: 'none',
                                    overflow: "hidden",
                                    wordBreak: 'break-word'
                                }}>{child.props.children}</span>
                            </li>
                        },
                    )}
                </ul>
            </div >
        );
    },
);

// value should be string for single select and array for multi select
// similarly onChange will have string argument for single select and array for multiselect
export function EdwExportButton(props) {

    const [open, setOpen] = useState(false);

    const selected = useMemo(() => {
        return Array.isArray(props.value) ? props.value : (
            props.value !== null && props.value !== undefined ? [props.value] : []
        );
    }, [props.value]);

    const selectedLabels = useMemo(() => {
        return selected.map(it => {
            const item = props.items.find(item => item.id === it);
            return item && item.label;
        });
    }, [selected, props.items]);

    function toggleDropdown() {
        setOpen(open => setOpen(!open));
    }

    function closeDropdown() {
        setOpen(false);
    }

    function onSelect(id) {
        if (props.multiple) {
            const index = selected.findIndex(item => item === id);
            if (index === -1) {
                props.onChange([...selected, id]);
            } else {
                props.onChange(selected.filter(item => item !== id))
            }
        } else {
            props.onChange(id);
            closeDropdown();
        }
    }

    function onSelectAll() {
        if (props.multiple) {
            if (selected.length === props.items.length) {
                props.onChange([]);
            } else {
                props.onChange(props.items.map(item => item.id))
            }
        }
    }

    const selectAllActive = selected.length === props.items.length;

    return (
        <Dropdown className="export-btn" show={open} onToggle={toggleDropdown}>
            <Dropdown.Toggle as={CustomToggle}>
                <span style={{ marginRight: 8,marginTop:2 }} className="ICONSGeneral18pxexportwhite-18"></span> {!props.multiple && selectedLabels.length > 0 ? selectedLabels[0] || props.label : props.label}
            </Dropdown.Toggle>
            <Dropdown.Menu
                as={CustomMenu} onSelect={onSelect} multiple={props.multiple}
                selectAllLabel={props.selectAllLabel} onSelectAll={onSelectAll} selectAllActive={selectAllActive}
            >
                {props.items.map(item => {
                    return <Dropdown.Item active={selected.includes(item.id)} key={item.id} id={item.id}>{item.label}</Dropdown.Item>;
                })}
            </Dropdown.Menu>
        </Dropdown>
    );
}

EdwExportButton.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({ id: PropTypes.string, label: PropTypes.string })
    ).isRequired,
    value: PropTypes.oneOf([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    multiple: PropTypes.bool,
    selectAllLabel: PropTypes.string,
}

EdwExportButton.defaultProps = {
    multiple: false,
    selectAllLabel: 'Select All'
}